"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryButton = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
function PrimaryButton(props) {
    var disabled = props.disabled, onClick = props.onClick, text = props.text, className = props.className, name = props.name, _a = props.type, type = _a === void 0 ? 'button' : _a, leftIcon = props.leftIcon, rightIcon = props.rightIcon, dataCy = props.dataCy;
    return (react_1.default.createElement("button", { 
        // eslint-disable-next-line react/button-has-type
        type: type, className: (0, clsx_1.default)('eva-primary-button center-content', className), disabled: disabled, onClick: onClick, name: name, "data-cy": dataCy },
        react_1.default.createElement("div", { className: "eva-primary-button__left-icon" }, leftIcon),
        react_1.default.createElement("span", { className: "eva-primary-button__text" },
            " ",
            text),
        react_1.default.createElement("div", { className: "eva-primary-button__right-icon" }, rightIcon)));
}
exports.default = PrimaryButton;
function SecondaryButton(props) {
    var onClick = props.onClick, text = props.text, className = props.className, dataCy = props.dataCy;
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('eva-secondary-button center-content', className), onClick: onClick, "data-cy": dataCy },
        react_1.default.createElement("span", { className: "eva-secondary-button__text" }, text)));
}
exports.SecondaryButton = SecondaryButton;
